/* Reviews slider product block: scroll-snap track with dots and arrows. */
(function () {
  if (customElements.get('product-reviews')) return;

  class ProductReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-reviews-track]');
      this.slides = Array.from(this.querySelectorAll('[data-reviews-slide]'));
      this.nav = this.querySelector('[data-reviews-nav]');
      this.dotsHolder = this.querySelector('[data-reviews-dots]');

      if (!this.track || !this.nav || !this.dotsHolder || this.slides.length < 2) return;

      this.nav.hidden = false;
      this.dots = this.slides.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-reviews__dot';
        dot.setAttribute('aria-label', `Review ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsHolder.appendChild(dot);
        return dot;
      });

      this.querySelector('[data-reviews-prev]')?.addEventListener('click', () => this.goTo(this.index - 1));
      this.querySelector('[data-reviews-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.update(), 80);
      }, { passive: true });

      this.update();
    }

    get index() {
      const width = this.track.clientWidth || 1;
      return Math.round(this.track.scrollLeft / width);
    }

    goTo(index) {
      const count = this.slides.length;
      const target = (index + count) % count;
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
    }

    update() {
      const current = this.index;
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === current));
    }
  }

  customElements.define('product-reviews', ProductReviews);
})();
